import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-done",
  "use": "icon-done-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-done\"><path d=\"M512 1024q218-5 362.5-149.5T1024 512q-5-218-149.5-362.5T512 0Q294 5 149.5 149.5T0 512q5 218 149.5 362.5T512 1024z m169-684q13-13 30-13t30 13q13 13 13 30t-12 30L484 659q-13 12-30.5 12T424 659L283 518q-13-13-13-30t13-30q13-13 30-13t30 13l111 110 227-228z\" fill=\"#40c9c6\" p-id=\"2843\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol